import * as React from 'react';
import styles from './assets/loader.module.scss';
import classNames from 'classnames';
export interface Props {
    noFull?: boolean;
}

const Loader: React.FunctionComponent<Props> = ({ noFull }) => (
    <div style={noFull ? {} : { position: 'fixed' }} className={classNames(styles.loader)}>
        <div className={classNames(styles.holder, 'd-flex', 'justify-content-center', 'align-items-center')}>
            <div className={classNames('spinner-border', 'text-primary')} role="status">
                <span className={classNames('sr-only')}>Loading...</span>
            </div>
        </div>
    </div>
);

export default Loader;
